import { FC } from 'react';
import { Dimensions, Issue, Message } from '@gripp/shared-logic';
import { StyleProp, TextStyle } from 'react-native';

export type MessageComponentProps = {
  message: Message;
  imageDimensions: Dimensions;
  mediaUrl: string;
  textStyle?: StyleProp<TextStyle>;
  issue: Issue;
  [key: string]: any;
};

export enum ReminderAlertType {
  Date = 'DATE',
  Days = 'DAYS',
  DayInterval = 'DAY_INTERVAL',
}

export enum ReminderAlertInputs {
  days = 'days',
  daysStartDate = 'daysStartDate',
  onDate = 'onDate',
  dayInterval = 'dayInterval',
  dayIntervalUnit = 'dayIntervalUnit',
  notes = 'notes',
}

export type ClearButtonProps = {
  inputType: ReminderAlertInputs;
};

export type DeleteLogicProps = ClearButtonProps;

export type MessageComponent = FC<MessageComponentProps>;
